import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { automaticService } from "services";
import { logout } from "../logout";

export const getAssemblyTest = createAsyncThunk(
  "getAssemblyTest",
  async (
    {
      assemblyId,
      assemblyTestId
    },
    { rejectWithValue }
  ) => {
    try {
      return await automaticService.getAssemblyTest(
        assemblyId,
        assemblyTestId
      );
    } catch (error) {
      if (error.message) {
        if (error?.response?.status === 401) {
          logout();
        }
        //No response to request (No service)
        console.log("Internet Disconnected");
      } else {
        console.log(error);
        return rejectWithValue(error);
      }
    }
  }
);

const initialState = {
  result: null,
  loading: false,
  error: null,
};

const assemblyTestSlice = createSlice({
  name: "assemblyTest",
  initialState: initialState,
  reducers: {
    clearAssemblyTest: (state, _action) => {
      state.result = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAssemblyTest.pending, (state, _action) => {
      state.loading = true;
    });
    builder.addCase(getAssemblyTest.fulfilled, (state, action) => {
      state.loading = false;
      state.result = state.result
        ? state.result.concat(action.payload)
        : action.payload;
      state.error = null;
    });
    builder.addCase(getAssemblyTest.rejected, (state, action) => {
      state.loading = false;
      state.result = null;
      state.error = action.payload;
    });
  },
});

export const { clearAssemblyTest } =
  assemblyTestSlice.actions;
export default assemblyTestSlice.reducer;
